import { PasswordRegExpManager } from '@speeki/utils';

export const passwordValid = (password?: string) =>
    !!(
        password &&
        PasswordRegExpManager.min_max_length.test(password) &&
        PasswordRegExpManager.uppercase.test(password) &&
        PasswordRegExpManager.lowercase.test(password) &&
        PasswordRegExpManager.min_number.test(password) &&
        PasswordRegExpManager.min_symbol.test(password)
    );
